import {
  disableAnimation,
  getSystemDarkSnapshot,
  isDarkMode,
  mergeDefaultOptions,
  subscribeSystemDark
} from "./chunk-XCMO6GM7.js";

// src/atom-dark.ts
import { atom as atom2 } from "jotai/vanilla";
import { atomWithStorage } from "jotai/vanilla/utils";
import { atomEffect } from "jotai-effect";

// src/atom-system-dark.ts
import { atom } from "jotai/vanilla";
function atomSystemDark() {
  const isSystemDarkAtom = atom(null);
  isSystemDarkAtom.onMount = (set) => {
    if (typeof window === "undefined")
      return;
    const update = () => {
      set(getSystemDarkSnapshot());
    };
    update();
    return subscribeSystemDark(update);
  };
  return isSystemDarkAtom;
}

// src/atom-dark.ts
function atomDark(options) {
  const {
    storageKey,
    disableTransition,
    disableTransitionExclude,
    applyDarkMode
  } = mergeDefaultOptions(options);
  const isSystemDarkAtom = atomSystemDark();
  if (import.meta.env?.MODE !== "production")
    isSystemDarkAtom.debugPrivate = true;
  const themeAtom = atomWithStorage(storageKey, "system");
  if (import.meta.env?.MODE !== "production")
    themeAtom.debugPrivate = true;
  const toggleDarkEffect = atomEffect((get, set) => {
    const theme = get(themeAtom);
    const isSystemDark = get(isSystemDarkAtom);
    const isDark = isDarkMode(theme, isSystemDark);
    const enable = disableTransition ? disableAnimation(disableTransitionExclude) : null;
    applyDarkMode(isDark);
    enable?.();
    if (theme === "dark" && isSystemDark || theme === "light" && !isSystemDark) {
      set(themeAtom, "system");
    }
  });
  if (import.meta.env?.MODE !== "production")
    toggleDarkEffect.debugPrivate = true;
  const anAtom = atom2(
    (get) => {
      get(toggleDarkEffect);
      const theme = get(themeAtom);
      const isSystemDark = get(isSystemDarkAtom);
      return isDarkMode(theme, isSystemDark);
    },
    (get, set) => {
      const theme = get(themeAtom);
      const isSystemDark = get(isSystemDarkAtom);
      if (theme === "system")
        set(themeAtom, isSystemDark ? "light" : "dark");
      else
        set(themeAtom, "system");
    }
  );
  return anAtom;
}
export {
  atomDark,
  atomSystemDark
};
